import { Map as ImmMap } from 'immutable';
import {
	FETCH_ERROR,
	IS_FETCHING,
	RECEIVE_SUB_CATEGORIES,
	TOGGLE_PRODUCTS_DISPLAY,
	TOGGLE_PRODUCTS_AND_CATEGORIES_DISPLAY,
	UPDATE_RECENT_CAT,
	UPDATE_SCROLL_POS,
} from './constants';

// Each of these are maps because they must store state for
// a list of categories and potentially a list of products.
// A subcategory can have other categories as childer and/or a list of
// products as its children.
export const initialState = new ImmMap({
	displayProducts: false,
	displayProductsAndCategories: false,
	fetchError: undefined,
	isFetching: false,
	subCategories: new ImmMap(),
	mostRecentCat: null,
	scrollPosition: 0,
});

const categoriesReducer = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_ERROR: {
			return state.set('fetchError', action.fetchError);
		}
		case IS_FETCHING: {
			return state.set('isFetching', action.isFetching);
		}
		case RECEIVE_SUB_CATEGORIES: {
			const { featuredImages, lastFetchTime, subCategories } = action;
			return state.mergeIn(['subCategories', action.categoryId], {
				featuredImages,
				lastFetchTime,
				subCategories,
			});
		}
		case TOGGLE_PRODUCTS_DISPLAY: {
			return state.set('displayProducts', action.displayProducts);
		}
		case TOGGLE_PRODUCTS_AND_CATEGORIES_DISPLAY: {
			return state.set('displayProductsAndCategories', action.displayProductsAndCategories);
		}
		case UPDATE_RECENT_CAT:
			return state.set('mostRecentCat', action.id);
		case UPDATE_SCROLL_POS:
			return state.set('scrollPosition', action.position);
		default:
			return state;
	}
};

export default categoriesReducer;
